/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Tour } from '../../models/tour';
import { VehicleAssignScheduledTourRequest } from '../../models/vehicle-assign-scheduled-tour-request';

export interface AssociateVehiclesWithTour$Params {

/**
 * Id of a resource.
 */
  id: string;
      body: VehicleAssignScheduledTourRequest
}

export function associateVehiclesWithTour(http: HttpClient, rootUrl: string, params: AssociateVehiclesWithTour$Params, context?: HttpContext): Observable<StrictHttpResponse<Tour>> {
  const rb = new RequestBuilder(rootUrl, associateVehiclesWithTour.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Tour>;
    })
  );
}

associateVehiclesWithTour.PATH = '/api/v1/tours/scheduled/{id}/associated_vehicles';
